import React from "react";
import PropTypes from "prop-types";
import {
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Switch,
  Select,
  Grid,
  GridItem,
  Button,
  Spacer,
  Tooltip,
  Badge,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
  Icon,
  Flex,
} from "@chakra-ui/react";
import moment from "moment";
const DateRender = ({ value }) => {
  const formatDate = (dateString) => {
    return moment(dateString).format("ll");
  };

  return <Text>{value ? formatDate(value) : "N/A"}</Text>;
};

DateRender.propTypes = {
  value: PropTypes.string,
};

export default DateRender;
